
<template>
  <b-alert show variant="danger" class="impersonation-alert" v-if="user.isImpersonating && user.impersonationPosition === position">
    <b-row>
      <span>Viewing site as {{ user.userId }}</span>
      <a href="/stopimpersonation" class="alert-link">[Stop Impersonation]</a>
      <a class="ml-2" href="" @click.prevent="changePosition()">Move to {{ inversePosition }}</a>
    </b-row>
  </b-alert>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    inversePosition() {
      return this.user.impersonationPosition === "top" ? "bottom" : "top";
    }
  },
  props: {
    position: {
      type: String,
      required: false,
      default: "top"
    }
  },
  methods: {
    ...mapActions(["changeImpersonationPosition"]),
    changePosition() {
      this.changeImpersonationPosition(this.inversePosition);
    }
  }
};
</script>
